import { UserCountryCode } from '@shared/types/countryCodes.ts';
import { CountryAssetKey, resolveCountryAssetKey } from '@shared/utils/resolveCountryAssetKey.ts';

export type IconSetKey = CountryAssetKey;

export function resolveIconSetKey(countryCode: UserCountryCode | null): IconSetKey {
  return resolveCountryAssetKey(countryCode);
}
